<template>
  <div v-if="user.id" class="profile">
    <!-- {{ $store.getters.isAgent }}
    {{ $store.getters.isCandidate }}
    {{ $store.getters.isEmployer }} -->
    <!-- {{ user }} -->
    <div class="profile-tile" style="margin-top: 20px;">
      <basic-info :user="user" @editBasicInfo="editBasicInfo()"></basic-info>
    </div>

    <div class="profile-tile">
      <h3 style="">Professional Information
        <img v-if="editAccess" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer; float: right;" @click="editProfessionalInfo()">
      </h3>
      <hr>
      <professional-info :user="user"></professional-info>
    </div>

    <div class="profile-tile">
      <div v-if="user.id">
        <references :user="user"></references>
      </div>
    </div>

    <!-- <div class="profile-tile">
      <h3 style="">Placement Details
        <img v-if="editAccess" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer; float: right;" @click="editDesiredRole()">
      </h3>
      <hr>
      <desired-role :user="user"></desired-role>
    </div> -->

    <div class="profile-tile">
      <div v-if="user.id">
        <documents :user="user" @infoSaved="infoSaved()"></documents>
      </div>
    </div>

    <!-- <div class="profile-tile" v-if="adminOrEmployer"> -->
    <div class="profile-tile" v-if="$store.getters.isAgent === true">
      <h3 style="">Additional Notes
        <img v-if="$store.getters.isAgent === true" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer; float: right;" @click="editNotes()">
      </h3>
      <hr>
      <pre>{{ user.text20 }}</pre>
    </div>

    <div v-if="user.id && !$store.getters.isAgent">
      <feedback :user="user"></feedback>
    </div>

    <modal name="basic-info-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <basic-info-form @basicInfoSaved="basicInfoSaved()" :user="user"></basic-info-form>
      </div>
    </modal>

    <modal name="professional-info-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <!-- <professional-info-form @professionalInfoSaved="professionalInfoSaved()" :user="user"></professional-info-form> -->
        <professional-info-form @infoSaved="infoSaved()" :user="user"></professional-info-form>
      </div>
    </modal>

    <modal name="desired-role-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <desired-role-form @infoSaved="infoSaved()" :user="user"></desired-role-form>
      </div>
    </modal>

    <modal name="notes-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <notes-form @infoSaved="infoSaved()" :user="user"></notes-form>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

// https://www.npmjs.com/package/vue-loading-overlay
import Vue from 'vue';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);

import BasicInfo from './BasicInfo'
import BasicInfoForm from './BasicInfoForm'
import ProfessionalInfo from './ProfessionalInfo'
import ProfessionalInfoForm from './ProfessionalInfoForm'
import DesiredRole from './DesiredRole'
import DesiredRoleForm from './DesiredRoleForm'
import References from './References'
import Documents from './Documents'
import NotesForm from './NotesForm'

import Feedback from "../../users/Feedback"

export default {
  props: ['user'],
  components: {
    BasicInfo,
    BasicInfoForm,
    ProfessionalInfo,
    ProfessionalInfoForm,
    DesiredRole,
    DesiredRoleForm,
    References,
    Documents,
    NotesForm,

    Feedback,
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    // viewOnlyAccess() {
    //   if (this.$store.getters.isEmployer === 'true') {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
  },
  data() {
    return {
      // user: {},
      // passedID: null,
    }
  },
  created() {
    // this.user = this.passedUser
    // this.passedID = this.$route.params.id
    // if (this.passedID) {
    //   this.getUser()
    // }
  },
  methods: {
    // getUser() {
    //   axios.get('/api/people/?id='.concat(this.passedID.toString()))
    //   .then(res => {
    //     console.log(res.data)
    //     this.user = res.data[0]
    //   })
    //     .catch(error => console.log(error))
    // },
    editBasicInfo() {
      this.$modal.show('basic-info-modal')
    },
    editProfessionalInfo() {
      this.$modal.show('professional-info-modal')
    },
    editDesiredRole() {
      this.$modal.show('desired-role-modal')
    },
    editNotes() {
      this.$modal.show('notes-modal')
    },
    basicInfoSaved() {
      this.$modal.hide('basic-info-modal')
      // this.getUser()
      this.$emit('userUpdated')
    },
    professionalInfoSaved() {
      this.$modal.hide('professional-info-modal')
      this.$emit('userUpdated')
    },
    infoSaved() {
      this.$modal.hide('basic-info-modal')
      this.$modal.hide('professional-info-modal')
      this.$modal.hide('desired-role-modal')
      this.$modal.hide('notes-modal')
      this.$emit('userUpdated')
    }
  },
}
</script>

<style>
  /* .profile-tile {
    border-radius: 6px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    padding: 1.5rem;
    margin-top: 40px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/candidates/profile/ProfileView.vue